export var SECOND_IN_MS = 1000;
export var MINUTE_IN_MS = SECOND_IN_MS * 60;
export var HOUR_IN_MS = MINUTE_IN_MS * 60;
export var DAY_IN_MS = HOUR_IN_MS * 24;
export var WEEK_IN_MS = DAY_IN_MS * 7;
export var MONTH_IN_MS = DAY_IN_MS * 30;
//# sourceMappingURL=TimeConstants.js.map